import { Injectable, inject } from '@angular/core';
import { ModuleType } from '@fi-app/shared/types/module-type';
import { FiLocalSearchParameterModel } from '@fi-app/shared/fi-local-search2/fi-local-search-parameter.model';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { IModuleTypesItem, ModuleTypesMap } from '@fi-shared/models/module-types';
import { AppTextService } from '@fi-shared/app-text';
import { IItemsListAction2, ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class FiTagHelperService {
    private accessToApplicationTypeService = inject(AccessToApplicationTypeService);
    private appTextService = inject(AppTextService);

    getTagModuleTypes() {
        const tagModuleTypes = [
            ModuleTypesMap[ModuleType.Document],
            ModuleTypesMap[ModuleType.MediaBank],
            ModuleTypesMap[ModuleType.Core],
        ];
        if (this.accessToApplicationTypeService.hasCustomerAccessToModule(ModuleType.CheckList))
            tagModuleTypes.push(ModuleTypesMap[ModuleType.CheckList]);

        return tagModuleTypes;
    }

    getTaggedItemFilter(ListData: any, tagId: number): FiLocalSearchParameterModel {
        const parameterModel = new FiLocalSearchParameterModel();
        Object.assign(parameterModel, ListData.getFilterParams());
        Object.assign(parameterModel, ListData.getOffsetParams());

        parameterModel.TagIds = [tagId];

        parameterModel.SelectedSort = {
            ColumnName: ListData.Sort.Column,
            SortDirection: ListData.Sort.Reverse,
        };

        return parameterModel;
    }

    getSideListOptionAll(): ISideListOptionsItem {
        return {
            value: 0,
            text: this.appTextService.get('ccmAppearance.listView.allTags'),
        };
    }

    getSideListOptions(): ISideListOptionsItem[] {
        return this.getTagModuleTypes().map((type: IModuleTypesItem) => {
            return {
                value: type.Id,
                text: this.appTextService.get(type.TextId),
            };
        });
    }

    getItemsListActions(deleteSelectedTags: () => void): IItemsListAction2[] {
        return [
            {
                title: this.appTextService.get('common.delete'),
                onClick: deleteSelectedTags,
            },
        ];
    }
}
